import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import networkHero from "../assets/Hero/network-security-infrastructure.jpg"; // Replace with your hero image
import networkImage from "../assets/Hero/network_infrastructure.jpg"; // Replace with your network image
import featuresImage from "../assets/Hero/Nairobi.jpg"; // Replace with your features image
import "../assets/css/networkInfrastructurePage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const networkData = {
  hero: {
    title: "Network Infrastructure & Security",
    subtitle: "Building Secure and Scalable Networks for Your Business",
  },
  introduction: {
    heading: "Why Network Infrastructure & Security Matters",
    paragraphs: [
      "A robust and secure network infrastructure is the backbone of any modern business. It ensures seamless communication, data integrity, and protection against cyber threats.",
      "Our solutions are designed to provide scalable, reliable, and secure networks that support your business growth and protect your critical assets.",
    ],
  },
  features: {
    heading: "Our Network Infrastructure & Security Features",
    items: [
      "Enterprise-Grade Network Design",
      "Firewall & Intrusion Detection Systems",
      "Secure VPNs for Remote Access",
      "Network Monitoring & Management",
      "Data Encryption & Compliance",
      "24/7 Security Support",
    ],
  },
  benefits: {
    heading: "Benefits of Our Solutions",
    items: [
      {
        icon: "fa fa-shield",
        text: "Enhanced network performance and reliability.",
      },
      {
        icon: "fa fa-lock",
        text: "Protection against cyber threats and data breaches.",
      },
      {
        icon: "fa fa-line-chart",
        text: "Scalable solutions that grow with your business.",
      },
      {
        icon: "fa fa-check-circle",
        text: "Compliance with industry standards and regulations.",
      },
      {
        icon: "fa fa-headphones",
        text: "Expert support and maintenance for uninterrupted operations.",
      },
    ],
  },
  cta: {
    heading: "Ready to Secure Your Network?",
    text: "Contact us today to learn more about our Network Infrastructure & Security solutions and how we can help protect your business.",
  },
};

export const NetworkInfrastructurePage = ({ data }) => {
  const networkRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = networkRef.current.querySelectorAll(".network-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: networkRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="network-page" ref={networkRef}>
      {/* Hero Section */}
      <div
        className="network-hero-section"
        style={{ backgroundImage: `url(${networkHero})` }}
      >
        <h1 className="network-animate">{networkData.hero.title}</h1>
        <p className="network-animate">{networkData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container network-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="network-animate">{networkData.introduction.heading}</h2>
            {networkData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="network-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 network-image-container">
            <img
              src={networkImage}
              className="img-fluid network-animate"
              alt="Network Infrastructure & Security"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container network-features">
        <div className="row">
          <div className="col-md-6 network-image-container">
            <img
              src={networkHero}
              className="img-fluid network-animate"
              alt="Network Features"
              style={{maxWidth: "100%"}}
            />
          </div>
          <div className="col-md-6">
            <h2 className="network-animate">{networkData.features.heading}</h2>
            <ul>
              {networkData.features.items.map((item, index) => (
                <li key={index} className="network-animate">
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Benefits Section */}
      <div
        className="container-fluid network-benefits"
        style={{ backgroundImage: `url(${featuresImage})` }}
      >
        <div className="overlay">
          <h2 className="network-animate">{networkData.benefits.heading}</h2>
          <div className="benefits-cards">
            {networkData.benefits.items.map((item, index) => (
              <div key={index} className="benefit-card network-animate">
                <i className={item.icon}></i>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container network-cta">
        <h2 className="network-animate">{networkData.cta.heading}</h2>
        <p className="network-animate">{networkData.cta.text}</p>
        <button
          className="btn btn-primary network-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};